import { formatCurrency } from '@/lib/display'

export const buildGrossProfitExport = ({ items, headers, isMonthly, year, month }) => {
  const exportHeaders = isMonthly
    ? headers.filter(header => header.value !== 'commissionDetails')
    : headers
  const keys = exportHeaders.map(header => header.value)
  const data = items.map(item => {
    const row = {}
    keys.forEach(key => {
      row[key] = key === 'grossProfit' ? formatCurrency(item[key]) : item[key]
    })
    return row
  })
  const period = isMonthly
    ? `${year}-${String(month).padStart(2, '0')}`
    : year

  return {
    title: exportHeaders.map(header => header.text),
    key: keys,
    data,
    autoWidthFlag: true,
    filename: `Gross Profit ${period}`
  }
}
